import { type KnownLocale } from "nvent-web/i18n";
import Certified from "nvent-web/assets/png/certified.png";

export const getLogoByCountryCode = async (
  locale: KnownLocale
): Promise<string> => {
  try {
    return await import(`nvent-web/assets/png/certified-${locale}.png`);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error: unknown) {
    return Certified;
  }
};
